import React, { Component } from 'react';
import parse from 'html-react-parser';
import _ from 'lodash';
// import CardMenu from './CardMenu';
// import ShortcutsModal from './ShortcutsModal';
import { Minimize2, Maximize2 } from 'react-feather';

export default class FlashCard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isFullscreen: false,
            cardWidth: 0,
            cardHeight: 0,
            isCardMenuOpen: false,
            cardMenuYPosition: 0,
            showShortcutsModal: false,
            IOIsPortrait: false,
            initializedDebounce: false, 
            debounced: null,
        }
    }

    componentDidMount() {
        if (this.props.card.model === 'multichoice') {
            document.body.classList.add('is-qbank');
        }

        // Suppress Card Menu on Outside Click
        document.addEventListener('mouseup', function (e) {
            if (this.state.isCardMenuOpen) {
                let trigger = document.getElementById('card-menu-trigger');
                if (trigger && !trigger.contains(e.target)) {
                    this.hideCardMenu();
                }
            }
        }.bind(this));

        window.addEventListener('resize', function() {
            if (this.state.isCardMenuOpen) {
                this.hideCardMenu();
            }
        }.bind(this));
        this.initializedDebounce();
        document.querySelector('html').style.height = '100%';
    }

    componentDidUpdate(prevProps) {
        this.addFlashcardListeners();
        if (this.props.card !== prevProps.card) {
            this.handleCardChange();
        }
    }

    componentWillUnmount() {
        this.removeKeyBinds();
        document.querySelector('html').style.height = 'auto';
        document.body.classList.remove('is-qbank');
        this.setState({ isFullscreen: false });
        document.body.classList.remove('is-fullscreen');
    }

    handleCardChange = () => {
        if (this.props.card.model === 'multichoice') {
            document.body.classList.add('is-qbank');
        } else {
            document.body.classList.remove('is-qbank');
        }
    }

    initializedDebounce = () => {
        if (!this.state.initializedDebounce) {
            const debounced = _.debounce(this.keyBinds, 50, { 'leading': true, 'trailing': false })
            window.addEventListener('keydown', debounced)
            this.setState({ initializedDebounce: true, debounced })
        }
    }

    removeKeyBinds = () => {
        if (this.state.initializedDebounce) {
            window.removeEventListener('keydown', this.state.debounced);
        }
    }

    keyBinds = (e) => {
        if (this !== e.target && (/textarea|select|input/i.test( e.target.nodeName ) || e.target.type === "text" || e.target.isContentEditable)) { return; }
    }

    addFlashcardListeners = () => {
        // Auto-play audio element
        setTimeout(this.autoplayAudio, 200);
    
        // Prevent base image from loading before overlay (apkg image occlusion)
        var mask = document.querySelector('#io-overlay>img');
        if (!!mask) {
            if (mask.complete) {
                this.overlayLoaded();
            } else {
                mask.addEventListener('load', this.overlayLoaded);
            }
        }
    }

    autoplayAudio = () => {
        const audioEl = document.getElementsByTagName('audio')[0];
        if (!!audioEl) {
            const src = audioEl?.children[0].src;
            if (src !== this.state.lastAudioSrc) {
                audioEl.load();
                audioEl.play();
                this.setState({ lastAudioSrc: src });
            }
        }
    }

    overlayLoaded = () => {
        var original = document.querySelector('#io-original');
        if (!!original) original.style.visibility = "visible";
    }

    hideCardMenu() {
        this.setState({isCardMenuOpen: false});
    }
    
    renderCardContent() {
        if (_.isEmpty(this.props.card) || this.props.loading) return null;

        if (this.props.isFlipped) {
            if (this.props.card.model === "occlusion") {
                if (!_.isEmpty(this.props.card.header)) {
                    return (
                        <>
                            {parse(this.props.card.question)}
                            <br></br>
                            {parse(this.props.card.header)}
                            {_.isEmpty(this.props.card.css) ? null : parse(this.props.card.css)}
                        </>
                    );
                } else {
                    return (parse(this.props.card.question));
                }
            } else if (this.props.card.model === "basic") {
                return (
                    <>
                        {parse(this.props.card.question)}
                        <hr className="solid"></hr>
                        {parse(this.props.card.answer)}
                        {_.isEmpty(this.props.card.css) ? null : parse(this.props.card.css)}
                    </>
                )
            } else {
                return (
                    <>
                        {parse(this.props.card.answer)}
                        {_.isEmpty(this.props.card.css) ? null : parse(this.props.card.css)}
                    </>
                )
            }
        } else {
            if (!_.isEmpty(this.props.card.header)) {
                return (
                    <>
                        {parse(this.props.card.question)}
                        <br></br>
                        {parse(this.props.card.header)}
                        {_.isEmpty(this.props.card.css) ? null : parse(this.props.card.css)}
                    </>
                );
            } else {
                return (
                    <>
                        {parse(this.props.card.question)}
                        {_.isEmpty(this.props.card.css) ? null : parse(this.props.card.css)}
                    </>
                )
            }
        }
    }

    renderOcclusionOverlay() {
        if (_.isEmpty(this.props.card)) return null;
        if (this.props.card.model === "occlusion") {
            return this.props.isFlipped ? 
                (parse(this.props.card.answer_overlay || '')) :
                (parse(this.props.card.question_overlay || ''))
        }
    }

    renderExtraContent() {
        if (this.props.isFlipped) {
            if (_.isEmpty(this.props.card) || _.isEmpty(this.props.card.extra)) return null;
            return (
                <div className="card__extra">
                    {parse(this.props.card.extra)}
                </div>
            )
        }
    }

    toggleFullscreen() {
        this.setState(state => ({ isFullscreen: !state.isFullscreen, cardWidth: document.querySelector('.card').offsetWidth, cardHeight: document.querySelector('.card').offsetHeight }));

        if (document.body.classList.contains('is-fullscreen')) {
            document.body.classList.remove('is-fullscreen');
            document.querySelectorAll('.focus-anchor').forEach(function(el) {
                el.setAttribute('tabIndex', '-1');
            });
        }
        else {
            document.body.classList.add('is-fullscreen');
            let focusable = document.querySelector('.button-bar').querySelectorAll('button');
            focusable[0].focus();
            document.querySelectorAll('.focus-anchor').forEach(function(el) {
                el.setAttribute('tabIndex', '0');
            });
        }
    }

    toggleCardMenu() {
        this.setState(state => ({isCardMenuOpen: !state.isCardMenuOpen, cardMenuYPosition: this.calculateCardMenuYPosition()}));
    }

    calculateCardMenuYPosition() {
        let wWidth = window.innerWidth;
        if (wWidth > 900) {
            return (document.getElementById('card-menu-trigger').getBoundingClientRect().top - document.querySelector('.layout--study').getBoundingClientRect().top).toString() + 'px';
        }
    }

    getIconName = () => {
        return this.state.isFullscreen ? <Minimize2/> : <Maximize2/>;
    }

    showShortcutsModal = () => {
        this.setState({ showShortcutsModal: true });
    }

    hideShortcutsModal = () => {
        this.setState({ showShortcutsModal: false });
    }

    handleLightboxClick = (e) => {
        if (this.props.lightboxState === 'off' && e.target.nodeName !== "IMG") {
            this.props.toggleLightbox('off');
            return;
        }
        if (this.props.lightboxState === 'off') {
            this.props.toggleLightbox('1x');
        } else {
            this.props.toggleLightbox('off');
        }
    }

    renderAllCardContent = () => {
        // New IO (Optimal)
        if (this.props.card.model === "occlusion") {
            return (
                <div className="card__image-occ__wrapper" onClick={(e) => this.handleLightboxClick(e)}>
                    {this.renderCardContent()}
                    {this.renderOcclusionOverlay()}
                    {this.renderExtraContent()}
                </div>
            );
        // Legacy IO Styling from Import Script
        } else if (this.props.card.model?.toLowerCase().includes('occlusion')) {
            return (
                <div className="io-content-wrapper" onClick={(e) => this.handleLightboxClick(e)}>
                    {this.renderCardContent()}
                    {this.renderOcclusionOverlay()}
                    {this.renderExtraContent()}
                </div>
            );
        } else if (this.props.card.model === 'multichoice') {
            return (
                <div className="qbank-content">
                    <div className='left'>
                        {this.renderCardContent()}
                    </div>
                    <div className='right'>
                        {this.renderExtraContent()}
                    </div>
                </div>
            );
        // All Other Cards
        } else {
            return (
                <div>
                    {this.renderCardContent()}
                    {this.renderOcclusionOverlay()}
                    {this.renderExtraContent()}
                </div>
            );
        }
    } 

    render() {
        return (
            <React.Fragment>
                <div className={`card ${this.props.card.model === 'multichoice' ? 'qbank' : ''}`}>
                    <div className="overflow-overlay overflow-overlay--top"></div>
                    <div className={`card__text lightbox-${this.props.lightboxState }${this.props.card.model?.toLowerCase().includes('occlusion') ? " is-image-occlusion" : ""}`}>
                        {this.renderAllCardContent()}
                    </div>
                    <div className="overflow-overlay"></div>
                </div>
            </React.Fragment>
        )
    }
}
